import {useCallback, useEffect, useState} from 'react'
import {GetShippingHistoryResponse, ShippingStatusType} from './apiTypes'
import {fetcher} from '../services/http.service'
import {format} from "date-fns";
import useSWR from "swr";
import {queries} from "./queries";

const MAX_SIZE = 100;

export function useShippingHistories(tracking_number?: string, t?: any) {
    const [result, setResult] = useState<{ histories: ShippingStatusType[], formattedDate: string }>({
        formattedDate: '',
        histories: []
    });

    const {data, error, isValidating, mutate} = useSWR<GetShippingHistoryResponse>(
        tracking_number ? `${queries.shipping.history(tracking_number)}?page_size=${MAX_SIZE}` : null,
        fetcher,
        {revalidateIfStale: false, revalidateOnFocus: false, revalidateOnReconnect: false}
    )
    const getDate = useCallback((histories: ShippingStatusType[]) => {
        let formatted = ''
        console.log('weekday', histories)
        if (histories && histories.length > 0) {
            try {
                const lastStatus = histories[histories.length - 1]
                const date = new Date(lastStatus.timestamp)
                const weekDay = t(format(date, 'EEE'))
                const time = format(date, 'HH:mm')
                const day = format(date, 'MM월 dd일')
                console.log('lastStatus weekday', lastStatus, format(date, 'EEE'), t(weekDay), histories)
                formatted = `${day} (${weekDay}) ${time}`
            } catch (error) {
                console.log('weekday format error', error)
            }
        }
        return formatted
    }, [t]);


    console.log("histories", data, result)
    useEffect(() => {
        if (data) {
            const histories = data.results;
            const formattedDate = getDate(histories);
            setResult({histories, formattedDate});
        }
    }, [data, getDate])

    return {
        result,
        isLoading: isValidating,
        mutate,
        isError: error,
    }
}
